export const filters = () => {

  const btnFilter= '.js-filter-category';
  const current = '.js-filter-current';
  const list = '.js-filters';
  const item =  '.js-item-to-filter';

  const btnSort= '.js-toggle-sort';
  const listToSort =  '.js-list-to-sort';

  //Variables to hide date on program after filtering
  const smallBr = 520;

  const init = () => {
    bind();
  };

  const bind = () => {

    $(btnSort).on('click', function(e) {
      e.preventDefault();
      $(this).attr('data-state', $(this).attr('data-state') == '' ? 'toggled' : '');
      if($(this).attr('data-state') == 'toggled') {
        $(this).text($(this).attr('data-text-toggled'));
      } else {
        $(this).text($(this).attr('data-text-not-toggled'));
      }
      //Toggle class which will reverse the order using flex-direction column-reversed.
      $(listToSort).toggleClass('is-reversed');
    });

    $(btnFilter).on('click', function(e) {
      e.preventDefault();
      //Removing class is-current from current filter, in order to show it again in the list.
      $(btnFilter).removeClass('is-current');
      //Add is-current class to the clicked filter to hide it from the list.
      $(this).addClass('is-current');
      //Then replace text of filter toggle with current filter text.
      $(current).text($(this).text());
      //Close the filters list
      $(list).attr('data-state', $(list).attr('data-state') =='closed' ? 'open' : 'closed');
      
      //Do the filtering
      let categories = $(this).attr('data-category');
      if(categories == '' || categories == 'all') {
        $(item).removeClass('is-hidden');
        document.body.classList.remove("is-filtered");
      } else {
        $(item).addClass('is-hidden');
        document.body.classList.add("is-filtered");
        $(item+'[data-categories*="'+categories+'"]').removeClass('is-hidden');
      }
    });

  };

  init();

};
